<!-- HwRechargeForm -->

<template>
  <div>
    <div class="hw-recharge-div">
      <div>账号: </div>
      <input v-model="recharge_number" placeholder="在这里输入您的充值账号" class="hw-recharge-input" />
    </div>

    <div class="hw-recharge-tip">请确认您输入的账号,提交后无法更正或追回</div>
  </div>
</template>

<script>
export default {
  props: ['goodsDetail'],

  data() {
    return {
      recharge_number: ''
    }
  },

  methods: {
    getRechargeNumber() {
      return this.recharge_number
    }
  }
}
</script>

<style scoped>
.hw-recharge-div {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
}

.hw-recharge-tip {
  color: red;
  font-size: 18px;
}

.hw-recharge-input::placeholder {
  color: #c0c0c0;
}

.hw-recharge-input {
  padding-left: 10px;
  border-width: 0;
}
</style>